"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "17",
    height: "19"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "#D7D8D7",
    d: "M.5.5h16v4H.5zM.5 14.5h16v4H.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.333 11.167H10V12H8v-.833h.667V7.833h.666v3.334zM8 7h2v.833H8V7z",
    fill: "#35A7F8"
  })));
};

exports["default"] = _default;